import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';
import { useCallback } from 'react';

import type { TValidationReason } from '../utils/validation';

/** The text of the first broken form rule. */
export function useValidationText(): (reason: TValidationReason) => string {
  const { t } = useFormatMessage();
  return useCallback(
    (reason: TValidationReason) => {
      switch (reason) {
        case 'validation.oneDefault':
          return t({
            id: 'announcements.validation.oneDefault',
            defaultMessage: 'Отметьте ровно один язык по умолчанию.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.duplicateLanguage':
          return t({
            id: 'announcements.validation.duplicateLanguage',
            defaultMessage: 'Каждый язык можно добавить только один раз.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.emptyText':
          return t({
            id: 'announcements.validation.emptyText',
            defaultMessage: 'Заполните заголовок и текст для каждого языка.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.version':
          return t({
            id: 'announcements.validation.version',
            defaultMessage: 'Укажите версию.',
            description: 'Ошибка формы карточки версии',
          });
        case 'validation.versionFormat':
          return t({
            id: 'announcements.validation.versionFormat',
            defaultMessage: 'Версия — от 1 до 4 чисел через точку, каждое от 0 до 999.',
            description: 'Ошибка формы карточки версии',
          });
        case 'validation.publishInFuture':
          return t({
            id: 'announcements.validation.publishInFuture',
            defaultMessage: 'Время публикации должно быть в будущем.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.endInFuture':
          return t({
            id: 'announcements.validation.endInFuture',
            defaultMessage: 'Дата окончания должна быть в будущем.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.endRequired':
          return t({
            id: 'announcements.validation.endRequired',
            defaultMessage: 'Для акции и техработ укажите дату окончания.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.endAfterPublish':
          return t({
            id: 'announcements.validation.endAfterPublish',
            defaultMessage: 'Дата окончания должна быть позже времени публикации.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.ctaBoth':
          return t({
            id: 'announcements.validation.ctaBoth',
            defaultMessage: 'Укажите и текст, и ссылку кнопки или оставьте оба поля пустыми.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.ctaHttps':
          return t({
            id: 'announcements.validation.ctaHttps',
            defaultMessage: 'Ссылка кнопки должна быть полным адресом https://.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.audienceVersion':
          return t({
            id: 'announcements.validation.audienceVersion',
            defaultMessage: 'Версии аудитории — от 1 до 4 чисел через точку, каждое от 0 до 999.',
            description: 'Ошибка формы анонса',
          });
        case 'validation.audienceVersionOrder':
          return t({
            id: 'announcements.validation.audienceVersionOrder',
            defaultMessage: 'Версия «от» должна быть не выше версии «до».',
            description: 'Ошибка формы анонса',
          });
      }
    },
    [t],
  );
}
